import React, { memo, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Box,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Tab,
  Tabs,
  Typography,
  Backdrop,
} from "@mui/material";
import AlertDialog from "../../../AlertDialog/AlertDialog";
import EmailIcon from "@mui/icons-material/Email";
import PrintIcon from "@mui/icons-material/Print";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import InvoiceTabPanel from "../../../Tab/InvoiceTabPanel";
import LoaderNew from "../../../Loader/LoaderNew";
import DownloadGoodsReceivePdf from "../../../Download/DownloadGoodsReceivePdf";

const GoodsReceiveOrientation = ({ open, onClose, data }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState("");
  const [page, setPage] = useState(1);
  const [orientation, setOrientation] = useState("portrait");
  const [value, setValue] = useState(0);
  const [isEmail, setIsEmail] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openBackdrop, setOpenBackdrop] = useState(false);

  useEffect(() => {
    if (open) {
      setLoading(false);
      setIsEmail(false);
      setPage(1);
      setOrientation("portrait");
      setValue(0);
    }
  }, [open]);

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setDialogContent("");
  };

  const handleClose = () => {
    setDialogOpen(false);
    setDialogContent("");
    setOpenBackdrop(false);
    onClose();
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleOrientationChange = (event) => {
    const { name } = event.target;
    setOrientation(name);
  };

  const handlePage = (event) => {
    setPage(parseInt(event.target.value, 10));
  };

  const handlePrint = () => {
    if (!data) {
      setDialogContent("No goods receive data found to print.");
      setDialogOpen(true);
      return;
    }

    setOpenBackdrop(true);
    try {
      const companyName = data.company_name || "Company Name";
      const printData = [{ ...data }];
      DownloadGoodsReceivePdf(printData, companyName, null, setOpenBackdrop, true, true, orientation);
    } catch (e) {
      console.error(e);
      setOpenBackdrop(false);
      setDialogContent("Error while printing goods receive report.");
      setDialogOpen(true);
    }
  };

  const handleSendEmail = () => {
    setDialogContent("Email functionality is not available for goods receive at this time.");
    setDialogOpen(true);
  };

  return (
    <div>
      <AlertDialog
        open={dialogOpen}
        setOpen={handleCloseDialog}
        title="Alert"
        message={dialogContent}
        buttonTitle="Ok"
      />
      <Backdrop open={openBackdrop} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: '#fff' }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="goods-receive-print-dialog"
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="goods-receive-print-dialog">
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 0 }}>
            <Tabs value={value} onChange={handleChange} aria-label="goods receive tabs">
              <Tab label="EMAIL" id="tab-0" aria-controls="tabpanel-0" sx={{ fontWeight: 600 }} />
              <Tab label="PRINT" id="tab-1" aria-controls="tabpanel-1" sx={{ fontWeight: 600 }} />
            </Tabs>
          </Box>
          <Box position="absolute" right={16} top={6}>
            <IconButton aria-label="close" onClick={handleClose}>
              <DisabledByDefaultIcon sx={{ fontSize: 32 }} color="error" />
            </IconButton>
          </Box>
        </DialogTitle>

        <InvoiceTabPanel value={value} index={0}>
          <Box textAlign="center">
            <Typography variant="h6" color="textSecondary">
              Save paper, send the goods receive report via email!
            </Typography>
            <br />
            {loading ? (
              <LoaderNew />
            ) : (
              <Button
                disabled={!isEmail}
                variant="contained"
                color="primary"
                startIcon={<EmailIcon />}
                onClick={handleSendEmail}
              >
                Send Email
              </Button>
            )}
            {!loading && !isEmail && (
              <Typography component="p" variant="body" color="error" p={2}>
                Email functionality is not available for goods receive records.
              </Typography>
            )}
          </Box>
        </InvoiceTabPanel>

        <InvoiceTabPanel value={value} index={1}>
          <Stack direction="column">
            <DialogContent>
              <Box mb={1}>
                <FormControl>
                  <FormLabel>No. of pages</FormLabel>
                  <RadioGroup row value={page} onChange={handlePage}>
                    <Stack direction="row">
                      <FormControlLabel value={1} control={<Radio />} label="1" />
                      <FormControlLabel value={2} control={<Radio />} label="2" />
                      <FormControlLabel value={3} control={<Radio />} label="3" />
                      <FormControlLabel value={4} control={<Radio />} label="4" />
                    </Stack>
                  </RadioGroup>
                </FormControl>
              </Box>
              <Box>
                <FormControl component="fieldset">
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={orientation === "landscape"}
                          onChange={handleOrientationChange}
                          name="landscape"
                        />
                      }
                      label="Landscape"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={orientation === "portrait"}
                          onChange={handleOrientationChange}
                          name="portrait"
                        />
                      }
                      label="Portrait"
                    />
                  </FormGroup>
                </FormControl>
              </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center" }}>
              <Button variant="contained" startIcon={<PrintIcon />} onClick={handlePrint}>
                Print
              </Button>
            </DialogActions>
          </Stack>
        </InvoiceTabPanel>
      </Dialog>
    </div>
  );
};

export default memo(GoodsReceiveOrientation);
